export const academyTypes = {
  quiz: "quiz",
  challenge: "challenge",
  certificate: "certificate"
};
